<script>
import { ref, computed, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import AuthService from '@/services/authService'
import UserService from '@/services/userService'
import UserMainService from '@/services/userMainService'
import randomColor from 'randomcolor'
import isValidUrl from '@/utils/urlValidator'
import TopBar from '@/components/TopBar.vue'
import config from '@/config'

export default {
    name: 'MainView',
    components: {
        TopBar
    },
    setup() {
        const router = useRouter()
        // const route = useRoute()

        const user = ref({
            name: '用户名',
            id: 1,
            userType: 1,
            avatar: require('@/assets/logo.png')
        })

        const apps = ref([
            { id: 1, name: 'OJ练习', desc: '在线编程练习', link: '/CppOJ/', icon: 'code', used: true },
            { id: 2, name: '任务清单', desc: '待办事项管理', link: '/todo', icon: 'list', used: true },
            { id: 3, name: '时间线', desc: '时间记录管理', link: '/TimeLine/', icon: 'timeline', used: false },
            { id: 4, name: '知识图谱', desc: '知识关系展示', link: '/graph', icon: 'share', used: false },
            { id: 5, name: '快速抢答', desc: '抢答与记忆训练', link: '/QuickResponse/', icon: 'quiz', used: false },
            { id: 6, name: '文件管理', desc: '文件上传下载', link: '/FileManage/', icon: 'folder', used: false },
            { id: 7, name: '数据可视化', desc: '数据图表展示', link: '/DataVisual/', icon: 'bar_chart', used: false },
            { id: 8, name: '未来引擎', desc: '天赋树系统', link: '/futureengine', icon: 'psychology', used: false }
        ])

        const userLinks = ref([
            // { id: 1, name: 'GitHub', url: 'https://github.com' },
            // { id: 2, name: 'Vue.js', url: 'https://vuejs.org' }
        ])

        const searchQuery = ref('')
        const showAddDialogFlag = ref(false)
        const newLink = ref({ name: '', url: '' })

        // 设置页面标题
        const setPageTitle = (title) => {
            document.title = title || '主控面板 - AJYYWEB'
        }

        // 在组件加载时设置标题
        setPageTitle('主控面板')

        const filteredApps = computed(() => {
            if (!searchQuery.value) {
                return apps.value.filter(app => app.used)
            }
            return apps.value.filter(app =>
                app.used &&
                (app.name.toLowerCase().includes(searchQuery.value.toLowerCase()) ||
                    app.desc.toLowerCase().includes(searchQuery.value.toLowerCase()))
            )
        })

        const availableApps = computed(() => {
            return apps.value.filter(app => !app.used)
        })

        const loadUserInfo = () => {
            console.log('加载用户信息');
            // 从本地存储获取当前用户信息
            const currentUser = AuthService.getCurrentUser();
            if (currentUser) {
                console.log('当前用户信息:', currentUser);
                user.value.name = currentUser.nickname || currentUser.username || '用户名';
                user.value.id = currentUser.userid || currentUser.id || 1;
                user.value.userType = currentUser.userType || 1;
                console.log("icon:", currentUser.icon);
                // 如果有头像信息，则更新头像路径
                if (currentUser.icon) {
                    // 规范化路径分隔符，将反斜杠转换为正斜杠
                    const normalizedIcon = currentUser.icon.replace(/\\/g, '/');
                    console.log('规范化后的icon路径:', normalizedIcon);

                    // 构建完整的后端服务器地址，确保头像从8000端口获取
                    if (normalizedIcon.startsWith('http')) {
                        console.log('完整URL:', normalizedIcon);
                        // 如果已经是完整URL，则直接使用
                        user.value.avatar = normalizedIcon;
                    } else if (normalizedIcon.startsWith('/extra-files/uploads/')) {
                        console.log('extra-files URL:', normalizedIcon);
                        // 从后端服务器的8000端口获取头像
                        user.value.avatar = `${config.API_BASE_URL}${normalizedIcon}`;
                    } else if (normalizedIcon.startsWith('uploads/')) {
                        console.log('uploads URL:', normalizedIcon);
                        // 从后端服务器的8000端口获取头像
                        //user.value.avatar = `${config.API_BASE_URL}/extra-files/${normalizedIcon}`;

                        user.value.avatar = `${config.API_BASE_URL}/extra-files/${normalizedIcon}`;
                        //查看地址：`${config.API_BASE_URL}/extra-files/${normalizedIcon}`;
                        console.log('user.value.avatar', user.value.avatar);
                    } else {
                        console.log('img URL:', normalizedIcon);
                        user.value.avatar = `${config.API_BASE_URL}/extra-files/uploads/${normalizedIcon}`;
                    }
                } else {
                    console.log('使用默认头像');
                    // 使用默认头像
                    user.value.avatar = require('@/assets/logo.png');
                }

                // 获取用户已订阅的应用
                loadUserApps();
            }
        }

        const loadUserApps = async () => {
            console.log('加载用户应用');
            try {
                // 使用现有的API获取所有应用
                const response = await UserMainService.getAllApps(user.value.userType);
                console.log('获取应用结果:', response);
                if (response.status === 200 && response.apps) {
                    console.log('获取应用数据成功:', response.apps);
                    // 更新应用列表为从API获取的应用
                    apps.value = response.apps.map(app => ({
                        id: app.id,
                        name: app.name,
                        desc: app.desc,
                        link: app.name === '任务清单' ? '/todo' : app.link,
                        icon: getAppIcon(app.name), // 根据应用名称设置图标
                        used: app.used || false // 如果API返回了used字段则使用，否则默认为false
                    }));
                }
            } catch (error) {
                console.error('获取应用数据失败:', error);
                // 如果获取失败，使用默认应用列表
                apps.value = apps.value.map(app => ({ ...app, used: app.id === 2 })); // 假设id为2的应用是默认已订阅的
            }
        }

        // 根据应用名称获取对应的图标
        const getAppIcon = (appName) => {
            const iconMap = {
                'OJ练习': 'code',
                '任务清单': 'list',
                '时间线': 'timeline',
                '知识图谱': 'share',
                '快速抢答': 'quiz',
                '文件管理': 'folder',
                '数据可视化': 'bar_chart',
            };
            return iconMap[appName] || 'code'; // 默认图标为code
        }

        // 获取应用图标图片路径
        const getAppIconImage = (appName) => {
            console.log('appName:', appName);
            // 这里可以根据需要添加特定应用的图标路径
            // 如果没有特定图标，则返回默认logo
            return require('@/assets/logo.png');
        }

        const handleImageError = (event) => {
            // 当头像加载失败时，使用默认头像
            event.target.src = require('@/assets/logo.png');
        }

        const handleStorageChange = (event) => {
            // 当localStorage发生变化时，重新加载用户信息
            if (event.key === 'user') {
                loadUserInfo();
            }
        }

        const getRandomColor = () => {
            return randomColor();
        }

        const navigateToApp = (link) => {
            console.log('导航到应用:', link);
            // 使用Vue Router进行导航
            if (link === '/todo') {
                router.push('/todo');
            } else if (link === '/graph') {
                router.push('/graph');
            } else if (link === '/filemanage') {
                router.push('/filemanage');
            } else if (link === '/futureengine') {
                router.push('/futureengine');
            } else {
                // 其他应用的导航逻辑可以在这里添加
                window.location.href = link;
            }
        }

        const showAddDialog = () => {
            showAddDialogFlag.value = true;
            loadAppData();
        }

        const closeAddDialog = () => {
            showAddDialogFlag.value = false;
        }

        const loadAppData = async () => {
            try {
                const data = await UserMainService.getAllApps(user.value.userType);
                console.log('获取应用数据:', data);
                // 更新应用列表
                // this.apps = data.apps;
                // this.userLinks = data.links;
            } catch (error) {
                console.error('获取应用数据失败:', error);
            }
        }

        const addApp = async (app) => {
            if (!app.used) {
                try {
                    const data = await UserService.addAppForUser(user.value.id, app.id);
                    console.log('添加应用成功:', data);
                    if (data.status === 200) {
                        app.used = true;
                        closeAddDialog();
                        // 重新加载用户应用列表
                        loadUserApps();
                    }
                } catch (error) {
                    console.error('添加应用失败:', error);
                }
            }
        }

        const addLink = async () => {
            if (newLink.value.name && newLink.value.url) {
                // 验证URL格式
                if (!isValidUrl(newLink.value.url)) {
                    alert('请输入有效的URL');
                    return;
                }

                try {
                    // 检查节点是否存在
                    const checkResult = await UserService.checkNode(newLink.value.name);
                    console.log('检查节点结果:', checkResult);

                    const linkData = {
                        name: newLink.value.name,
                        link: newLink.value.url
                    };

                    const data = await UserService.addLink(linkData);
                    console.log('添加链接成功:', data);

                    if (data.status === 200) {
                        const link = {
                            id: userLinks.value.length + 1,
                            name: newLink.value.name,
                            url: newLink.value.url
                        };
                        userLinks.value.push(link);
                        newLink.value.name = '';
                        newLink.value.url = '';
                    }
                } catch (error) {
                    console.error('添加链接失败:', error);
                }
            }
        }

        const deleteLink = async (id) => {
            try {
                const data = await UserService.deleteGraph(id);
                console.log('删除链接成功:', data);

                if (data.status === 200) {
                    const index = userLinks.value.findIndex(link => link.id === id);
                    if (index !== -1) {
                        userLinks.value.splice(index, 1);
                    }
                }
            } catch (error) {
                console.error('删除链接失败:', error);
            }
        }

        const handleLogout = async () => {
            try {
                await AuthService.logout();
                // 跳转到登录页面
                router.push('/login');
            } catch (error) {
                console.error('登出失败:', error);
            }
        }

        onMounted(() => {
            loadUserInfo();
            window.addEventListener('storage', handleStorageChange);
        })

        return {
            user,
            apps,
            userLinks,
            searchQuery,
            showAddDialogFlag,
            newLink,
            filteredApps,
            availableApps,
            loadUserInfo,
            loadUserApps,
            getAppIcon,
            getAppIconImage,
            handleImageError,
            handleStorageChange,
            getRandomColor,
            navigateToApp,
            showAddDialog,
            closeAddDialog,
            loadAppData,
            addApp,
            addLink,
            deleteLink,
            handleLogout
        }
    }
}
</script>

<template>
    <div class="main-view">
        <!-- 使用TopBar组件 -->
        <TopBar :user="user" :apps="apps" />

        <div class="search-container">
            <input v-model="searchQuery" type="text" class="search-input" placeholder="搜索应用..." />
        </div>

        <div class="circle-cards">
            <div v-for="app in filteredApps" :key="app.id" class="circle-card" @click="navigateToApp(app.link)">
                <div class="tech-circle">
                    <!-- 显示图标字符或默认图标 -->
                    <div v-if="getAppIcon(app.name) !== 'code'" class="card-icon">{{ getAppIcon(app.name) }}</div>
                    <img v-else :src="getAppIconImage(app.name)" :alt="app.name" class="app-icon-image" />
                    <div class="card-name">{{ app.name }}</div>
                    <div class="card-desc">{{ app.desc }}</div>
                </div>
            </div>
        </div>

        <div class="user-links">
            <h3>我的链接</h3>
            <div class="link-list">
                <div v-for="link in userLinks" :key="link.id" class="link-item"
                    :style="{ backgroundColor: getRandomColor() }">
                    <a :href="link.url" target="_blank">{{ link.name }}</a>
                    <button class="delete-btn" @click="deleteLink(link.id)">×</button>
                </div>
            </div>
            <div class="add-link">
                <input v-model="newLink.name" type="text" placeholder="链接名称" />
                <input v-model="newLink.url" type="text" placeholder="链接地址" />
                <button @click="addLink">添加</button>
            </div>
        </div>

        <div class="add-app-button">
            <button @click="showAddDialog">+</button>
        </div>

        <div v-if="showAddDialogFlag" class="add-dialog" @click="closeAddDialog">
            <div class="dialog-content" @click.stop>
                <h3>添加应用</h3>
                <div class="app-grid">
                    <div v-for="app in availableApps" :key="app.id" class="app-item" :class="{ selected: app.used }"
                        @click="addApp(app)">
                        <div class="app-icon">{{ getAppIcon(app.name) }}</div>
                        <div class="app-name">{{ app.name }}</div>
                    </div>
                </div>
                <button class="close-btn" @click="closeAddDialog">×</button>
            </div>
        </div>
    </div>
</template>

<style scoped>
.main-view {
    padding: 20px;
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
}

.search-container {
    text-align: center;
    margin-bottom: 30px;
}

.search-input {
    width: 300px;
    padding: 12px 20px;
    font-size: 16px;
    border: 2px solid #ddd;
    border-radius: 25px;
    outline: none;
    transition: border-color 0.3s;
}

.search-input:focus {
    border-color: #42b983;
}

.circle-cards {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
    gap: 30px;
    margin-bottom: 30px;
    justify-items: center;
}

.circle-card {
    width: 130px;
    height: 130px;
    position: relative;
    cursor: pointer;
    perspective: 1000px;
}

/* 科技感背景圆形 */
.tech-circle {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background: radial-gradient(circle at 30% 30%, rgba(0, 198, 255, 0.7), rgba(0, 114, 255, 0.7));
    box-shadow:
        0 0 20px rgba(0, 114, 255, 0.5),
        inset 0 0 20px rgba(0, 0, 0, 0.2);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
    overflow: hidden;
    z-index: 2;
}

/* 悬停效果 */
.circle-card:hover .tech-circle {
    transform: scale(1.05) rotate(5deg);
    box-shadow:
        0 0 30px rgba(0, 114, 255, 0.8),
        inset 0 0 30px rgba(0, 0, 0, 0.3);
    background: radial-gradient(circle at 30% 30%, rgba(0, 198, 255, 0.8), rgba(0, 114, 255, 0.8));
}

/* 内部发光效果 */
.tech-circle::before {
    content: '';
    position: absolute;
    top: -50%;
    left: -50%;
    width: 200%;
    height: 200%;
    background: radial-gradient(circle, rgba(255, 255, 255, 0.3) 0%, rgba(255, 255, 255, 0) 70%);
    transform: rotate(30deg);
    opacity: 0.2;
    transition: all 0.4s ease;
}

.circle-card:hover .tech-circle::before {
    transform: rotate(60deg);
    opacity: 0.6;
}

/* 边框光环效果 */
.tech-circle::after {
    content: '';
    position: absolute;
    top: -5px;
    left: -5px;
    right: -5px;
    bottom: -5px;
    border-radius: 50%;
    border: 2px solid transparent;
    background: linear-gradient(45deg, #00c6ff, #0072ff, #00c6ff) border-box;
    mask: linear-gradient(#fff 0 0) padding-box, linear-gradient(#fff 0 0);
    mask-composite: exclude;
    opacity: 0;
    transition: opacity 0.3s ease;
    z-index: -1;
}

.circle-card:hover .tech-circle::after {
    opacity: 1;
}

.card-icon {
    font-size: 32px;
    color: white;
    margin-bottom: 8px;
    text-shadow: 0 0 10px rgba(255, 255, 255, 0.7);
    transition: all 0.3s ease;
}

.circle-card:hover .card-icon {
    transform: scale(1.2);
    text-shadow: 0 0 15px rgba(255, 255, 255, 0.9);
}

.card-name {
    font-size: 14px;
    color: white;
    font-weight: bold;
    text-shadow: 0 0 5px rgba(0, 0, 0, 0.5);
    transition: all 0.3s ease;
}

.circle-card:hover .card-name {
    transform: scale(1.05);
}

.card-desc {
    font-size: 10px;
    color: rgba(255, 255, 255, 0.8);
    text-align: center;
    padding: 0 5px;
    transition: all 0.3s ease;
}

.circle-card:hover .card-desc {
    color: white;
}

/* 图标图片样式 */
.app-icon-image {
    width: 40px;
    height: 40px;
    margin-bottom: 8px;
    border-radius: 50%;
    object-fit: cover;
    border: 2px solid rgba(255, 255, 255, 0.3);
}

.user-links {
    background: white;
    padding: 20px;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    margin-bottom: 30px;
}

.user-links h3 {
    margin-top: 0;
    color: #333;
}

.link-list {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    margin-bottom: 20px;
}

.link-item {
    display: flex;
    align-items: center;
    padding: 8px 12px;
    border-radius: 20px;
    color: white;
    position: relative;
}

.link-item a {
    color: white;
    text-decoration: none;
    flex-grow: 1;
}

.delete-btn {
    background: rgba(255, 255, 255, 0.3);
    border: none;
    border-radius: 50%;
    width: 20px;
    height: 20px;
    color: white;
    cursor: pointer;
    margin-left: 8px;
}

.add-link {
    display: flex;
    gap: 10px;
}

.add-link input {
    flex-grow: 1;
    padding: 8px 12px;
    border: 1px solid #ddd;
    border-radius: 4px;
}

.add-link button {
    padding: 8px 15px;
    background: #42b983;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
}

.add-app-button {
    position: fixed;
    bottom: 30px;
    right: 30px;
}

.add-app-button button {
    width: 50px;
    height: 50px;
    border-radius: 50%;
    background: #42b983;
    color: white;
    font-size: 24px;
    border: none;
    cursor: pointer;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.add-dialog {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
}

.dialog-content {
    background: white;
    padding: 30px;
    border-radius: 8px;
    max-width: 500px;
    width: 90%;
    max-height: 80vh;
    overflow-y: auto;
}

.dialog-content h3 {
    margin-top: 0;
    text-align: center;
}

.app-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
    gap: 15px;
    margin: 20px 0;
}

.app-item {
    text-align: center;
    padding: 15px;
    border: 2px solid #eee;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.3s ease;
}

.app-item:hover {
    border-color: #42b983;
    transform: translateY(-2px);
}

.app-item.selected {
    border-color: #42b983;
    background: rgba(66, 185, 131, 0.1);
}

.app-icon {
    font-size: 24px;
    margin-bottom: 8px;
}

.app-name {
    font-size: 14px;
    color: #333;
}

.close-btn {
    position: absolute;
    top: 50px;
    right: 50px;
    background: none;
    border: none;
    font-size: 36px;
    cursor: pointer;
    color: white;
    width: 50px;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
}

.close-btn:hover {
    color: #333;
    background-color: #f0f0f0;
}
</style>